export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-secondary-500/10 rounded-lg p-8 md:p-10 flex flex-col lg:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50">
            <i className="ri-download-cloud-2-line text-2xl md:text-3xl"></i>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-lg md:text-2xl text-foreground-950 mb-2">
              APP下载
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xl">
              酷漫屋移动端APP专为竖屏条漫阅读打造，支持离线下载、阅读进度云同步、个性化推荐等功能。无论在地铁上还是睡前，打开APP就能畅享丝滑的下拉式漫画阅读体验。iOS和Android双平台均已上架。
            </p>
          </div>

          <div className="flex-shrink-0 flex flex-col sm:flex-row gap-3">
            <a
              href="#app"
              className="px-6 py-2.5 bg-foreground-950 text-background-50 text-sm font-semibold rounded-md hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-apple-fill mr-1.5"></i>iOS 下载
            </a>
            <a
              href="#app"
              className="px-6 py-2.5 bg-accent-500 text-background-50 text-sm font-semibold rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-android-fill mr-1.5"></i>Android 下载
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}